import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { logo } from "../assets";

const ResetPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [status, setStatus] = useState("loading");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Extract token from URL
  const token = new URLSearchParams(location.search).get("token");

  useEffect(() => {
    if (!token) {
      setStatus("invalid");
      return;
    }
    setStatus("ready");
  }, [token]);

  const handleResetPassword = async () => {
    if (!newPassword || !confirmPassword) {
      toast.error("Please fill in all fields!");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/reset-password/${token}`,
        { newPassword }
      );
      toast.success(response.data.message);
      navigate("/login");
    } catch (error) {
      toast.error(error.response?.data?.message || "Error resetting password.");
    }

    setIsSubmitting(false);
  };

  return (
    <div className="flex max-md:flex-col w-screen h-screen">
      <div className="flex flex-col w-1/2 max-md:w-full h-full max-md:h-[35%] bg-gray-100 justify-center items-center border-r">
        <img src={logo} alt="Thirtify Logo" className="w-24 h-fit rounded-lg object-contain" />
      </div>
      <div className="flex flex-col w-1/2 max-md:w-full h-full max-md:h-[65%] overflow-y-auto scrollbar-hide justify-center items-center">
        <div className="w-full max-w-sm p-6">
          {status === "loading" && <h2 className="text-2xl font-bold text-center mb-6">Loading...</h2>}
          {status === "invalid" && <h2 className="text-2xl font-bold text-center mb-6 text-red-600">❌ Invalid Reset Link</h2>}
          {status === "ready" && (
            <div>
              <h2 className="text-2xl font-bold text-center mb-6">Reset Your Password</h2>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="New Password"
                className="w-full p-2 border border-gray-300 rounded mb-4"
                disabled={isSubmitting}
              />
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm Password"
                className="w-full p-2 border border-gray-300 rounded mb-4"
                disabled={isSubmitting}
              />
              <button
                onClick={handleResetPassword}
                className={`w-full py-2 rounded text-white ${isSubmitting ? "bg-gray-400 cursor-not-allowed" : "bg-rose-600 hover:bg-blue-700"}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Reset Password"}
              </button>
            </div>
          )}
          <div className="text-center mt-4">
            <button onClick={() => navigate("/login")} className="text-rose-600 hover:underline">Go to Login</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;